import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { MemoryRouter } from "react-router-dom";
import ContextMenu from "react-context-menu";
import App from './App';
import { storefrontPopupDeviceTypesCollection } from './components/constants/storefrontPopupConstants';

const copyStylesIntoIframe = (iframeDoc) => {
    // Copy <link> stylesheets
    const links = Array.from(document.querySelectorAll('link[rel="stylesheet"]'));
    links.forEach(link => {
        const clone = link.cloneNode(true);
        iframeDoc.head.appendChild(clone);
    });

    // Copy inline <style> tags (useful in dev)
    const styles = Array.from(document.querySelectorAll("style"));
    styles.forEach(style => {
        const clone = style.cloneNode(true);
        iframeDoc.head.appendChild(clone);
    });

    // Basic meta so 1 CSS pixel = 1 device pixel inside iframe
    const meta = iframeDoc.createElement("meta");
    meta.setAttribute("name", "viewport");
    meta.setAttribute("content", "width=device-width, initial-scale=1");
    iframeDoc.head.appendChild(meta);
}


const AppDevicePreview = () => {
  const [selected, setSelected] = useState(storefrontPopupDeviceTypesCollection[0]);
  const iframeRef = useRef(null);
  const rightClickMenu = useRef(null);
  const [mountNode, setMountNode] = useState(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;
    const onLoad = () => {
      const doc = iframe.contentDocument;
      // Reset doc
      doc.open();
      doc.write(`<!doctype html><html><head></head><body><div id="app-root"></div></body></html>`);
      doc.close();
      copyStylesIntoIframe(doc);
      // Some basic reset to remove default margins and let the app take full height
      const reset = doc.createElement("style");
      reset.textContent = `
        html, body, #app-root { height: 100%; margin: 0; }
      `;
      doc.head.appendChild(reset);
      setMountNode(doc.getElementById("app-root"));
    };
    // Trigger initial load
    if (iframe.contentDocument.readyState === "complete") onLoad();
    else iframe.addEventListener("load", onLoad);
    return () => iframe.removeEventListener("load", onLoad);
  }, []);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe || !mountNode) return;
    iframe.contentWindow.location = (window.location.hash || "") + (window.location.search || "")
  }, [mountNode])

  // Mouting app inside iframe
  if (window.self !== window.top) {
    return (
      <MemoryRouter>
        <App
          selectedDevice={selected?.device}
        />
      </MemoryRouter>
    );
  }

  return (
    <div>
      {/* Hidden content menu element to ensure context element is pre-created in dom */}
      <div className='d-none'>
        <ContextMenu
          contextId="root"
          ref={rightClickMenu}
          items={[]}
        />
      </div>

      {/* Hidden device preview dock to update iframe width */}
      <div className='storefront-devices-preview-icon-container d-none'>
        {storefrontPopupDeviceTypesCollection.map((v, index) => (
          <div
            key={index}
            className={`storefront-devices-preview-icon-box storefront-devices-preview-icon-box-main-${v.device} ${v.widthMedia === selected.widthMedia ? "selected" : ""}`}
            onClick={() => {
              setSelected(v)
            }}
            dangerouslySetInnerHTML={{ __html: v.svg }}
          ></div>
        ))}
      </div>

      {/* Centered device frame */}
      <div className='storefront-device-preview-iframe-container'>
        <div>
          <iframe
            ref={iframeRef}
            id="iframeMain"
            className='storefront-device-preview-iframe-styles'
            style={{
              width: !selected.widthMedia ? "100vw" : selected.widthMedia
            }}
          />
        </div>
      </div>

      {/* Initially mounting fragment inside the iframe via a portal */}
      {mountNode &&
        ReactDOM.createPortal(
          <></>,
          mountNode
        )
      }
    </div>
  );
}

export default AppDevicePreview;

